import React, { useState } from "react";

import { AiFillDelete } from "react-icons/ai";
import "react-toastify/dist/ReactToastify.css";
import { HouseRuleInput, HouseRuleItem, HouseRulesExamples } from "../components/HouseRules";

var Modal = require("react-bootstrap-modal");

export function HouseRules({
  onNext,
  onPrev,
  formData,
  setFormData,
  className,
  saveAsDraft,
  draftRequesting,
}) {
  const [houseRules, setHouseRules] = useState(formData["houseRules"] || []);
  const [rule, setRule] = useState("");

  const [editingIndex, setEditingIndex] = useState(null);
  const [editingText, setEditingText] = useState("");

  const countWords = (text) => {
    if (!text.trim()) return 0;
    return text.trim().split(/\s+/).length;
  };

  const startEditing = (index) => {
    setEditingIndex(index);
    setEditingText(houseRules[index]);
  };

  const saveEdit = () => {
    const trimmedText = editingText.trim();
    if (trimmedText && countWords(trimmedText) >= 1 && countWords(trimmedText) <= 100) {
      const updatedRules = [...houseRules];
      updatedRules[editingIndex] = trimmedText;
      setHouseRules(updatedRules);
      cancelEdit();
    }
  };

  const cancelEdit = () => {
    setEditingIndex(null);
    setEditingText("");
  };

  const handleRules = (curr) => {
    if (curr) {
      setHouseRules([...houseRules, curr]);
      setRule("");
      setFormData({ ...formData, houseRules: [...houseRules, curr] });
    }
  };

  const deleteRule = (id) => {
    const ruleArr = [...houseRules];
    ruleArr.splice(id, 1);
    setHouseRules([...ruleArr]);
    setFormData({ ...formData, houseRules: ruleArr });
  };

  const handleNextStep = () => {
    setFormData({ ...formData, houseRules: houseRules });
    window.scrollTo({ top: 0, behavior: "smooth" });
    houseRules.length && onNext();
  };

  const saveAsdraft = () => {
    setFormData({ ...formData, houseRules: houseRules });
    // houseRules.length && saveAsDraft();
    saveAsDraft();
  };

  return (
    <div className={className}>
      <div className="  ">
        <div className="row gx-5">
          <h4 className="mb-5 h-min tw-flex tw-justify-start tw-items-center">
            <span className="tw-bg-[#23426e] tw-mr-2 tw-flex tw-justify-center tw-items-center  tw-h-10 tw-w-10 tw-text-white  tw-rounded-full">
              3
            </span>{" "}
            House Rules
          </h4>
          <div className="col-lg-6">
            {Boolean(houseRules.length) ? (
              <div className="mb-2">
                {houseRules.map((curr, index) => {
                  return <HouseRuleItem     
                  index={index}
                  rule={curr}
                  editingIndex={editingIndex}
                  editingText={editingText}
                  setEditingText={setEditingText}
                  startEditing={startEditing}
                  cancelEdit={cancelEdit}
                  saveEdit={saveEdit}
                  deleteRule={deleteRule}
                  wordLimit={100}
                  />
              })}
              </div>
            ) : (
              <p className="tw-mb-4 tw-text-center tw-text-gray-600 tw-text-xl ">
                No rules added
              </p>
            )}
            <div className="mb-2 tw-flex tw-items-center">
              <HouseRuleInput rule={rule} setRule={setRule} wordLimit={100} handleSave={() => handleRules(rule)}/>
              <button
                onClick={() => handleRules(rule)}
                type="button"
                className="btn btn-sm btn-primary m-2 "
              >
                Add
              </button>
            </div>
          </div>
          <HouseRulesExamples/>
        </div>
      </div>
      <div>
        <button
          onClick={onPrev}
          type="button"
          className="btn btn-secondary mx-2  tw-mb-2"
        >
          Prev
        </button>
        <button
          onClick={handleNextStep}
          type="submit"
          className="btn btn-secondary mx-2 tw-mb-2"
        >
          Next
        </button>
        <button
          type="button"
          disabled={draftRequesting}
          onClick={saveAsdraft}
          className="btn btn-secondary mx-2 tw-mb-2"
        >
          {draftRequesting ? "Adding ..." : "Save as Draft"}
        </button>
      </div>
    </div>
  );
}
